<style lang="less">
.village-contrast-container {
  width: 750px;
  height: 100%;
  background: #f7f7f7;
  #contrast_map {
    width: 100%;
    height: 320px;
  }
  .contrast-main {
    width: 718px;
    padding: 0 16px;
    background: #f7f7f7;
    .area-score {
      background: #fff;
      box-shadow: 0px 0px 8px 0px rgba(219, 219, 219, 0.5);
      border-radius: 6px;
      .area-score-top {
        padding: 24px 24px 0;
        .area-score-info {
          margin-bottom: 18px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .area-score-info-left {
            // margin-left: 98px;
            .area-item {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-top: 40px;
              position: relative;
              .area-itrm-quan {
                position: absolute;
                left: 0;
                top:40%;
                width: 14px;
                height: 14px;
                border-radius: 14px;
              }
              span{
                margin-left: 34px;
                font-size:26px;
                color:rgba(35,44,55,1);
              }
            }
          }
          .area-score-info-right {
            width: 350px;
            height: 300px;
            .charts-bar {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .area-score-bottom {
      }
    }
    .market-performance {
      padding: 24px;
      .charts-radar {
        width: 100%;
        height: 500px;
      }
    }
    .rent-trend {
      padding: 24px;
      .contrast-line {
        width: 100%;
        height: 350px;
        margin-top: 48px;
      }
    }
    .rent-type{
      padding: 24px;
      .stack-style{
        width: 100%;
        height: 300px;
      }
      .satck-legend{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        li{
          display: flex;
          justify-content: center;
          align-items: center;
          line-height: 32px;
          margin-left: 20px;
        }
        .quan{
          width: 10px;
          height: 10px;
          border-radius: 10px;
          margin-right: 10px;
        }
      }
    }
    .rent-trend-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .selsec-rent-type {
          display: flex;
          justify-content: center;
          align-items: center;
          li {
            margin-left: 64px;
            font-size: 26px;
            color: rgba(137, 147, 159, 1);
          }
          .selected {
            color: #4169e1;
          }
        }
      }
  }
  .main-style {
    background: #fff;
    box-shadow: 0px 0px 8px 0px rgba(219, 219, 219, 0.5);
    border-radius: 6px;
    margin-top: 18px;
  }
  .table-title-style {
    padding: 24px 24px 14px;
  }
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(35, 44, 55, 1);
    line-height: 44px;
    text-align: left;
  }
  table {
    width: 100%;
    th,
    td {
      border: 2px solid #eeeeee;
      border-left: none;
      border-bottom: none;
      padding: 16px 0 16px 22px;
      text-align: left;
      font-size: 24px;
      color: rgba(35, 44, 55, 1);
    }
    .no-border {
      border-right: none;
    }
    .table-header {
      font-weight: 600;
    }
    .table-header-one {
      color: rgba(137, 147, 159, 1);
    }
  }
  .footer{
    height:36px;
    font-size:26px;
    color:rgba(189,195,206,1);
    line-height:36px;
    margin: 32px 0 34px;
  }
  .no-contrast{
    background: #F7F7F7;
    width: 100%;
    height: 100%;
    padding-top: 16px;
    .content{
      background: #fff;
      padding-top: 110px;
      .desc{
        height:40px;
        font-size:28px;
        color:rgba(111,120,132,1);
        line-height:40px;
      }
      .return-last{
        width:340px;
        height:88px;
        background:rgba(65,105,225,1);
        border-radius:5px;
        color: #fff;
        border: none;
        margin-top: 80px;
      }
    }
  }
}
</style>
<template>
    <div class="village-contrast-container">
      <div v-if="!noContrast">
        <div id="contrast_map"></div>
        <div class="contrast-main">
            <div class="area-score">
                <div class="area-score-top">
                    <div class="title">小区评分</div>
                    <div class="area-score-info">
                        <div class="area-score-info-left">
                            <ul>
                                <li
                                    class="area-item"
                                    v-for="(item,index) in scoreList"
                                    :key="index"
                                >
                                    <div
                                        class="area-itrm-quan"
                                        :style="index==0?'backgroundColor:#698EFF':index==1?'backgroundColor:#4ACAA8':'backgroundColor:#F5A623'"
                                    ></div>
                                    <span>{{item.name}}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="area-score-info-right">
                          <Bar class="charts-bar" v-if="scoreList.length>0" :yData="scoreList"></Bar>
                        </div>
                    </div>
                </div>
                <div class="area-score-bottom">
                    <table cellspacing="0">
                        <thead>
                            <tr>
                                <th class="table-header-one">对比项</th>
                                <th
                                    class="table-header"
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.name}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="table-header">所属区域</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.area}}</td>
                            </tr>
                            <tr>
                                <td class="table-header">所属商圈</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.zone}}</td>
                            </tr>
                            <tr>
                                <td class="table-header">月租金</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.unitRentPrice}}元/㎡</td>
                            </tr>
                            <tr>
                                <td class="table-header">挂牌量</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.houseNum}}</td>
                            </tr>
                            <tr>
                                <td class="table-header">挂牌周期</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.activeDate}}天</td>
                            </tr>
                            <tr>
                                <td class="table-header">2km地铁站</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.subwaySiteCount}}</td>
                            </tr>
                            <tr>
                                <td class="table-header">2km地铁线</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.subwayLineCount}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="market-performance main-style">
                <div class="title">步行指数</div>
                <Radar class="charts-radar" id="village-contrast-radar" v-if="cellWalkList.length>0" :radar="cellWalkList"></Radar>
            </div>
            <div class="rent-type main-style">
                <div class="rent-trend-header">
                  <div class="title">在租户型</div>
                  <ul class="selsec-rent-type">
                      <li
                          v-for="(item,index) in rentList"
                          :key="index"
                          :class="selectRentType==index?'selected':''"
                          @click="selectRentingType(index)"
                      >{{item}}</li>
                  </ul>
                </div>
                <Stack class="stack-style" v-if="rentTrend.length>0" :stack="rentTrend"></Stack>
                <ul class="satck-legend">
                  <li
                      v-for="(item,index) in rentTypeList"
                      :key="index"
                  >
                    <div class="quan" :style="index==0?'backgroundColor:#4ACAA8':index==1?'backgroundColor:#FF8E55':index==2?'backgroundColor:#698EFF':'backgroundColor:#FFCC5C'"></div>
                    <span>{{item}}</span>
                  </li>
                </ul>
            </div>
            <!-- <div class="rent-trend main-style">
                <div class="rent-trend-header">
                  <div class="title">租金走势</div>
                  <ul class="selsec-rent-type">
                      <li
                          v-for="(item,index) in rentList"
                          :key="index"
                          :class="selectRentType==index?'selected':''"
                      >{{item}}</li>
                  </ul>
                </div>
                <div ref="contrast-line" class="contrast-line"></div>
            </div> -->
            <div class="business-district-matching main-style">
                <div class="table-title-style">
                  <div class="title">小区概况</div>
                </div>
                <table cellspacing="0">
                    <thead>
                        <tr>
                            <th class="table-header-one">属性</th>
                            <th
                                class="table-header"
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.name}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="table-header">建成年代</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                             <span v-if="item.completeTime">{{item.completeTime}}年</span>
                             <span v-else>暂无信息</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-header">楼栋数</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                              <span v-if="item.buildingCount">{{item.buildingCount}}栋</span>
                              <span v-else>暂无信息</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-header">总户数</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                              <span v-if="item.houseCount">{{item.houseCount}}户</span>
                              <span v-else>暂无信息</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-header">供暖方式</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.withHeating==1?'集中供暖':'无供暖'}}</td>
                        </tr>
                        <tr>
                            <td class="table-header">产权年限</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                              <span v-if="item.buildingLife">{{item.buildingLife}}年</span>
                              <span v-else>暂无信息</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-header">停车位</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                              <span v-if="item.parkInfo">{{item.parkInfo}}</span>
                              <span v-else>暂无信息</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-header">有无电梯</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                              <span v-if="item.elevator">{{item.elevator}}</span>
                              <span v-else>暂无信息</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-header">绿化率</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                              <span v-if="item.greenRate">{{item.greenRate}}%</span>
                              <span v-else>暂无信息</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-header">容积率</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                              <span v-if="item.plotRatio">{{item.plotRatio}}%</span>
                              <span v-else>暂无信息</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-header">物业公司</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                              <span v-if="item.propertyName">{{item.propertyName}}</span>
                              <span v-else>暂无信息</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-header">物业费</td>
                            <td
                                v-for="(item,index) in cellSumsInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >
                              <span v-if="item.propertyFee">{{item.propertyFee}}元/㎡/月</span>
                              <span v-else>暂无信息</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </div>
        <div class="no-contrast" v-if="noContrast">
          <div class="content">
            <div class="desc">没有添加商圈哦～</div>
            <button class="return-last" @click="returnLast">返回上一页</button>
          </div>
        </div>
    </div>
</template>

<script>
var map;
import { Progress, Dialog, Popup, Toast } from "vant";
import Bar from "@/components/echarts_bar-radius";
import Stack from "@/components/echarts_bar-stack";
import Radar from "@/components/echarts_radar";
let timestampStart,timestampEnd;
export default {
  name: "contrast",
  components: {
    Progress,
    Bar,
    Radar,
    Stack,
    "van-popup": Popup
  },
  data() {
    return {
      cityId: 30,
      noOpenDeatil: true,
      scoreList: [],
      rentList: ["全部", "整租", "合租"],
      rentTypeList: ["1居", "2居", "3居","4居+"],
      selectRentType: 0,
      contrastArr:[],
      compareList:[],
      rentTrend:[],
      cellSumsInfoList:[],
      cellWalkList:[],
      noContrast:false
    };
  },
  directives: {
    debounce: {
      inserted: function(el, binding) {
        let timer;
        el.addEventListener("click", () => {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            binding.value();
          }, 500);
        });
      }
    }
  },
  created() {
    timestampStart = (new Date()).getTime();
    this.addBuried({
      source:'1',
      eventType: '曝光事件',
      eventContent: '小区对比'
    });
    let options = this.$route.query;
    this.contrastArr = JSON.parse(localStorage.getItem('cellContrastArr'));
    if (!this.contrastArr||this.contrastArr.length<1) {
      this.noContrast = true;
      return false;
    }
    this.getCellCompare();
    this.getRentTrend();
    this.getCellSums();
    this.getCellWalk();
  },
  mounted() {
    this.onReachBottom(e=>{
      this.addBuried({
        source:'1',
        eventType: '触底事件',
        eventContent: '小区对比'
      });
    });
    map = new BMap.Map("contrast_map");
    var point = new BMap.Point(116.404, 39.915);
    map.centerAndZoom(point, 12);
    // map.disableDragging();
    map.disableDoubleClickZoom();
    map.disableScrollWheelZoom();
    map.disablePinchToZoom();
    this.getPointScore();
    map.addEventListener("touchmove", e => {
      this.noOpenDeatil = false;
      map.enableDragging();
    });
    map.addEventListener("touchend", e => {
      this.noOpenDeatil = true;
      map.disableDragging();
    });
  },
  methods: {
    returnLast(){
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateBack({
            delta: 1
          });
        } else {
          this.$router.go(-1);
        }
      });
    },
    getPointScore(first) {
      const toast1 = Toast.loading({
        duration: 300, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner"
      });
      let self = this;
      let param;
      param = {
        type:2,
        ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
      };
      this.$axios
        .post("api/xz/compare/score/", param)
        .then(res => {
          if (res.success) {
            let open = true;
            let mp = map;
            //定义自定义覆盖物的构造函数
            //1、定义构造函数并继承Overlay
            function ComplexCustomOverlay(point, title, score) {
              this._point = point;
              this._title = title;
              this._score = score;
            } // 继承API的BMap.Overlay
            ComplexCustomOverlay.prototype = new BMap.Overlay();
            //2、初始化自定义覆盖物
            // 实现初始化方法
            ComplexCustomOverlay.prototype.initialize = function(map) {
              // this.se = false;//禁止清除marker
              // 保存map对象实例
              this._map = map;
              // 创建div元素，作为自定义覆盖物的容器
              var div = (this._div = document.createElement("div"));
              div.style.position = "absolute";
              div.style.color = "#fff";
              div.style.lineHeight = "28px";
              div.style.height = "28px";
              div.style.padding = "0 10px";
              div.style.whiteSpace = "nowrap";
              div.style.MozUserSelect = "none";
              div.style.fontSize = "13px";
              div.style.textAlign = "center";
              div.style.backgroundColor = "#4169E1";
              div.style.borderRadius = "14px";
              div.style.border = "1px solid #fff";
              var div1 = (this._div1 = document.createElement("span"));
              div1.innerHTML = this._title;
              div.appendChild(div1);
              var div2 = (this._div2 = document.createElement("span"));
              div2.style.fontWeight = "bold";
              div2.style.marginLeft = "4px";
              div2.innerHTML = this._score + "分";
              div.appendChild(div2); // 将div添加到覆盖物容器中
              var div4 = (this._div4 = document.createElement("img"));
              div4.src = require('../../assets/img/area_close.png');
              div4.style.width = "15px";
              div4.style.height = "15px";
              div4.style.position = "absolute";
              div4.style.top = "-5px";
              div4.style.right = "-5px";
              // div4.innerHTML = "×";
              div.appendChild(div4);
              mp.getPanes().labelPane.appendChild(div); //getPanes(),返回值:MapPane,返回地图覆盖物容器列表  labelPane呢???
              // 需要将div元素作为方法的返回值，当调用该覆盖物的show、
              // hide方法，或者对覆盖物进行移除时，API都将操作此元素。
              return div;
            };
            //3、绘制覆盖物
            // 实现绘制方法
            ComplexCustomOverlay.prototype.draw = function() {
              var map = this._map;
              var pixel = map.pointToOverlayPixel(this._point);
              this._div.style.left = pixel.x + "px";
              this._div.style.top = pixel.y - 30 + "px";
            };
            //4、自定义覆盖物添加事件方法
            ComplexCustomOverlay.prototype.addEventListener = function(
              event,
              fun
            ) {
              this._div["on" + event] = fun;
            };
            // let scoreList = res.result.slice(0, 3);
            let scoreList = res.result;
            self.scoreList = scoreList;
            let scoreLen = scoreList.length;
            let pointArr = [];
            for (let i = 0; i < scoreLen; i++) {
              var myCompOverlay = new ComplexCustomOverlay(
                new BMap.Point(scoreList[i].longitude, scoreList[i].latitude),
                scoreList[i].name,
                scoreList[i].value
              );
              mp.addOverlay(myCompOverlay); //将标注添加到地图中
              pointArr.push(
                new BMap.Point(scoreList[i].longitude, scoreList[i].latitude)
              );
              toast1.clear();
              myCompOverlay._div4.addEventListener("touchend", () => {
                if (!self.noOpenDeatil) {
                  return false;
                }
                mp.addEventListener("click", function(e) {
                  self.addBuried({
                    source: "1",
                    eventType: "点击事件",
                    eventContent: "删除对比小区"
                  });
                  let overlaysArr = mp.getOverlays();
                  for (let j = 0; j < overlaysArr.length; j++) {
                    if (overlaysArr[j]._title == scoreList[i].name) {
                      mp.removeOverlay(overlaysArr[j]);
                      let contrastArr = JSON.parse(localStorage.getItem('cellContrastArr'));
                      for (let n = 0; n < contrastArr.length; n++) {
                        if (contrastArr[n] == scoreList[i].id) {
                          contrastArr.splice(n,1)
                        }
                      }
                      localStorage.setItem('cellContrastArr',JSON.stringify(contrastArr));
                      self.contrastArr = contrastArr;
                      if (!self.contrastArr||self.contrastArr.length<1) {
                        self.noContrast = true;
                        return false;
                      }
                      self.getPointScore();
                      self.getCellCompare();
                      self.getRentTrend();
                      self.getCellSums();
                      self.getCellWalk();
                    }
                  }
                });
              });
            }
            map.setViewport(pointArr);
          }
        })
        .catch(err => {
          toast1.clear();
          console.log(err);
        });
    },
    //获取小区对比项
    getCellCompare(){
      this.$axios
        .post("api/xz/compare/community/", {
          ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
        })
        .then(res => {
          if (res.success) {
            this.compareList = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //选择在租户型
    selectRentingType(e){
      this.selectRentType = e;
      if (e==0) {
        this.getRentTrend()
      }else if (e==1) {
        this.getRentTrend(e)
      }else{
        this.getRentTrend(e)
      }
    },
    //获取在租户型信息
    getRentTrend(rentType){
      this.$axios
        .post("api/xz/compare/house/", {
          ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0],
          rentType:rentType
        })
        .then(res => {
          if (res.success) {
            this.rentTrend = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取小区概括
    getCellSums(){
      this.$axios
        .post("api/xz/community/sums/", {
          ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
        })
        .then(res => {
          if (res.success) {
            this.cellSumsInfoList = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取小区步行指数
    getCellWalk(){
      this.$axios
        .post("api/xz/compare/walk/score/", {
          communityIds:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
        })
        .then(res => {
          if (res.success) {
            this.cellWalkList = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  destroyed () {
    timestampEnd = (new Date()).getTime();
    let residenceTime = timestampEnd-timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '小区对比停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/village_contrast/index.vue